import brand from '@helpers/brand';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { contentStyles, h4 } from '@helpers/typography';
import SectionWrapper, { Background, ContentType, } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled, { css } from 'styled-components';
export const gridColumns = css `
  grid-column: 1 / -1;

  @media ${from(Device.Tablet)} {
    grid-column: 2 / -2;
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: 3 / -3;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 4 / -4;
  }
`;
export const leftGridColumns = css `
  grid-column: 1 / -1;

  @media ${from(Device.Tablet)} {
    grid-column: 1 / span 10;
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: 1 / span 8;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 1 / span 6;
  }
`;
const Container = styled(SectionWrapper) `
  // Needed for accessibility, the dark green marginally fails contrast ratios
  &[data-background=${Background.Grey}][data-type=${ContentType.Default}] {
    --listColour: #278237;
  }

  &[data-type=${ContentType.Intermediaries}] {
    --listColour: ${brand.blue.navy};
    --quoteColour: ${brand.green.medium};
  }

  &[data-type=${ContentType.Savings}] {
    --listColour: ${brand.blue.dark};
    --quoteColour: ${brand.blue.default};
  }

  ${SectionWrapperStyles.Inner} {
    ${baseGrid};
  }
`;
const Title = styled.h2 `
  ${h4};

  margin-bottom: 1.75rem;

  ${Container}[data-layout='default'] & {
    ${gridColumns};
  }

  ${Container}[data-layout='left'] & {
    ${leftGridColumns};
  }
`;
const Content = styled.div `
  ${contentStyles};

  li span {
    display: inline-block;
    vertical-align: top;
  }

  ${Container}[data-layout='default'] & {
    ${gridColumns};
  }

  ${Container}[data-layout='left'] & {
    ${leftGridColumns};
  }
`;
const RichTextStyles = {
    Container,
    Title,
    Content,
};
export default RichTextStyles;
